import createSelectors from './createSelectors';
import Participation from '../models/Participation';

const Select = createSelectors(Participation, {});

export default Select;
